import React, { useEffect, useState } from "react"
import {
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  Row,
  Table,
} from "reactstrap"
import SelectBox from "components/Common/SelectBox"
import Select from "react-select"
import SButton from "components/Common/Button"
import { useHistory, useLocation } from "react-router-dom"
import {
  getRetailListPaymentApi,
  getRetailListSingleApi,
  updateRetailListApi,
} from "helpers/retail_list_helper"
import Breadcrumb from "components/Common/Breadcrumb"
import DateInput from "components/Common/DateInput"
import BackButton from "components/Common/BackButton"
import moment from "moment"

export default function Index(props) {
  const history = useHistory()
  const {
    state: { id },
  } = useLocation()

  const [data, setData] = useState(null)

  const [payload, setPayload] = useState({ payments: [] })

  const [payments, setPayments] = useState([])
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [unitPricesIndex, setUnitPricesIndex] = useState(null)
  const [amount, setAmount] = useState(0)

  const [paymentMethodOptions, setPaymentMethodsOptions] = useState([])
  const [paymentMethodValue, setPaymentMethodValue] = useState({
    label: "",
    value: "",
  })

  const [paymentDate, setPaymentDate] = useState("")
  const [paymentMethodId, setPaymentMethodId] = useState(null)
  const [paymentAmount, setPaymentAmount] = useState(0)

  const loadData = async () => {
    try {
      const { data } = await getRetailListSingleApi({ id })
      const _payload = { ...payload, payments: data.payments }

      setPayload(_payload)
      setData({ ...data })
      setPayments([...data.payments])
    } catch (error) {
      console.log(error)
    }
  }

  const loadPaymentMethods = async () => {
    try {
      const { data } = await getRetailListPaymentApi()
      const _paymentOptions = data.map(item => ({
        label: item.name,
        value: item.id,
      }))
      setPaymentMethodsOptions(_paymentOptions)
    } catch (error) {
      console.log(error)
    }
  }

  const handleInput = obj => {
    switch (obj.type) {
      case "paymentDate": {
        // const _d = new Date(obj.e).toISOString().slice(0, 10)
        const _d = moment(obj.e).format("YYYY-MM-DD")
        setPaymentDate(_d)
        break
      }
      case "paymentMethodId": {
        const { val } = obj
        setPaymentMethodValue(val)
        setPaymentMethodId(val.value)
        break
      }

      case "amount": {
        setPaymentAmount(+obj.e.target.value)
        break
      }
    }
  }
  const handleSubmit = async () => {
    try {
      const _payload = {
        ...payload,
        payments: payload.payments.map(item => ({
          id: item.id || null,
          paymentMethodId: item.paymentMethodId,
          paymentDate: item.paymentDate,
          amount: item.amount,
        })),
      }
      const res = await updateRetailListApi({ params: _payload, id })

      if (res.status === 200) history.push("/retail-list")
    } catch (error) {
      console.log(error)
    }
  }
  const addPayment = () => {
    if (!paymentDate || !paymentMethodId || !paymentAmount) return

    const _payments = [...payments]
    const _payment = {
      paymentDate: moment(paymentDate).format("YYYY-MM-DD"),
      amount: paymentAmount,
      paymentMethodId,
    }
    if (isEdit) {
      Object.assign(_payments[unitPricesIndex], _payment)
    } else {
      _payments.push(_payment)
    }

    const _payload = { ...payload, payments: _payments }
    setPayments(_payments)
    setPayload(_payload)
    setPaymentDate(null)
    setPaymentMethodValue({
      label: "",
      value: "",
    })
    setAmount("")
    setUnitPricesIndex(null)
    setIsEdit(false)
    setModal(!modal)
  }

  useEffect(() => {
    loadData()
    loadPaymentMethods()
  }, [])

  const getPaymentName = id => {
    if (!paymentMethodOptions.length) return ""
    const paymentMethodOption = paymentMethodOptions.find(
      item => item.value === id
    )

    if (paymentMethodOption) return paymentMethodOption.label
    return ""
  }
  if (!data) return null

  const toggle = () => setModal(!modal)

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb title="RTW小売詳細" breadcrumbList={[]} />
        <Card>
          <CardBody>
            <p>受注詳細</p>
            <Row>
              <Col sm={3}>
                <FormGroup row>
                  <Label sm={3}>顧客名</Label>
                  <Col sm={9}>
                    {data.guest ? (
                      <Input
                        type="text"
                        value={data.customerName || ""}
                        readOnly
                        disabled
                      />
                    ) : (
                      <SelectBox
                        options={[]}
                        value={{
                          label: data.customerName,
                          value: data.customerName,
                        }}
                        isDisabled
                      />
                    )}
                  </Col>
                </FormGroup>
              </Col>
              <Col sm={1} className="d-flex align-items-center">
                <Input
                  type="checkbox"
                  id="guest"
                  style={{ marginBottom: "19px" }}
                  checked={data.guest}
                  readOnly
                  disabled
                />
                <Label
                  className="ms-2"
                  htmlFor="guest"
                  style={{ marginBottom: "19px" }}
                >
                  ゲスト
                </Label>
              </Col>
              <Col sm={3}>
                <FormGroup row>
                  <Label sm={3}>受注日</Label>
                  <Col sm={9}>
                    <DateInput
                      value={data.orderDate}
                      className="form-control"
                      disabled
                    />
                  </Col>
                </FormGroup>
              </Col>
              <Col sm={5}>
                <div className="d-flex align-items-center justify-content-end">
                  <SButton className="button" onClick={handleSubmit}>
                    保存
                  </SButton>
                  <BackButton className="ms-2 button" />
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Row className="mt-4">
          <Col sm={12}>
            <Card>
              <CardBody>
                <Table bordered>
                  <thead>
                    <tr className="text-center">
                      <th style={{ width: 215 }}> RTW商品番号 </th>
                      <th> 商品名 </th>
                      <th> 単価 </th>
                      <th style={{ width: 85 }}> 数 </th>
                      <th style={{ width: 205 }}> 割引 </th>
                      <th style={{ width: 145 }}> 合計金額 </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.details?.length &&
                      data.details.map((detail, idx) => (
                        <tr key={idx}>
                          <td>{detail.productNumber}</td>
                          <td>{detail.productName}</td>
                          <td>{detail.unitPrice.toLocaleString("ja-JP")}</td>
                          <td>
                            <Input
                              type="number"
                              className="text-end"
                              value={detail.number}
                              readOnly
                              disabled
                            />
                          </td>
                          <td>
                            <Row>
                              <Col sm={5}>
                                <Input
                                  type="select"
                                  value={detail.discountType}
                                  disabled
                                  readOnly
                                >
                                  <option value="%">%</option>
                                  <option value="円">円</option>
                                </Input>
                              </Col>
                              <Col sm={7}>
                                <Input
                                  type="text"
                                  value={detail.discount.toLocaleString(
                                    "ja-JP"
                                  )}
                                  className="text-end"
                                  disabled
                                  readOnly
                                />
                              </Col>
                            </Row>
                          </td>
                          <td>
                            <Input
                              type="text"
                              className="text-end"
                              value={detail.amount.toLocaleString("ja-JP")}
                              readOnly
                              disabled
                            />
                          </td>
                        </tr>
                      ))}
                    {data?.details?.length && (
                      <tr>
                        <td> </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <th className="text-center">合計</th>
                        <th className="text-end">
                          {data.details
                            .reduce((acc, val) => acc + val.amount, 0)
                            .toLocaleString("ja-JP")}
                        </th>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <Card>
              <CardBody>
                <Row>
                  <Col className="d-flex justify-content-end mb-2 " md={12}>
                    <SButton onClick={toggle} className="button">
                      登録
                    </SButton>
                  </Col>
                </Row>

                <Table bordered className="mt-2">
                  <thead>
                    <tr className="text-center">
                      <th>日付</th>
                      <th>入金方法</th>
                      <th>金額</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {payments?.length && paymentMethodOptions.length
                      ? payments.map((payment, idx) => (
                          <tr key={idx}>
                            <td>{payment.paymentDate}</td>
                            <td>{getPaymentName(payment.paymentMethodId)}</td>
                            <td>{payment.amount.toLocaleString("ja-JP")}</td>
                            <td>
                              <SButton
                                onClick={() => {
                                  setUnitPricesIndex(idx)
                                  setPaymentDate(payment.paymentDate)
                                  setAmount(payment.amount)
                                  setPaymentMethodValue({
                                    value: payment.paymentMethodId,
                                    label: getPaymentName(
                                      payment.paymentMethodId
                                    ),
                                  })
                                  setPaymentAmount(payment.amount)
                                  setPaymentMethodId(payment.paymentMethodId)

                                  setIsEdit(true)
                                  toggle()
                                }}
                                size="sm"
                                className="button"
                              >
                                編集
                              </SButton>
                            </td>
                          </tr>
                        ))
                      : ""}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Modal isOpen={modal} toggle={toggle}>
          <ModalBody>
            <FormGroup row>
              <Label sm={2} htmlFor="paymentDate">
                日付
              </Label>
              <Col sm={10}>
                <DateInput
                  value={paymentDate}
                  className="form-control"
                  onChange={([e]) => {
                    handleInput({ e, type: "paymentDate" })
                    setPaymentDate(e)
                  }}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label htmlFor="paymentMethodId" sm={2}>
                入金方法
              </Label>
              <Col sm={10}>
                <Select
                  options={paymentMethodOptions}
                  value={paymentMethodValue}
                  isClearable
                  onChange={val =>
                    handleInput({ val, type: "paymentMethodId" })
                  }
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label htmlFor="amount" sm={2}>
                代金回収
              </Label>
              <Col sm={10}>
                <input
                  className="form-control"
                  id="amount"
                  type="number"
                  value={amount}
                  min={0}
                  onChange={e => {
                    handleInput({ e, type: "amount" })
                    setAmount(e.target.value)
                  }}
                />
              </Col>
            </FormGroup>
            <Row>
              <Col sm={12} className="d-flex justify-content-end">
                <SButton className="button" onClick={addPayment}>
                  登録
                </SButton>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </Container>
    </div>
  )
}
